import React, { useEffect, useState } from 'react';
import { IconButton, ButtonBase } from '@mui/material';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import CloseIcon from '@mui/icons-material/Close';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import Typography from '@mui/material/Typography';
import { useMutation } from '@apollo/client';
import styles from './EditPaymentMethodModal.module.scss';
import { UPDATE_USER_PAYMENT_METHOD } from '../../../../../api';

const paymentMethods = [
  { value: 'stripe', label: 'Stripe' },
  { value: 'shopify', label: 'Shopify' },
];

const EditPaymentMethodModal = ({
  open,
  handleClose,
  userFullName,
  userId,
  userPaymentMethod,
  setAdminUsersList,
}) => {
  const [checkedPaymentMethod, setCheckedPaymentMethod] = useState('');
  const [updateUserPaymentMethod] = useMutation(UPDATE_USER_PAYMENT_METHOD, {
    variables: { input: {} },
  });

  useEffect(() => {
    setCheckedPaymentMethod(userPaymentMethod);
  }, [open, userPaymentMethod]);

  const handleChangePaymentMethod = async (paymentMethod) => {
    try {
      await updateUserPaymentMethod({
        variables: {
          input: {
            user_id: userId,
            payment_method: paymentMethod,
          },
        },
      }).then((response) => {
        // Debug: Log the API response to see what we're getting
        console.log('Payment method update response:', response.data);

        // Use the API response data if available
        if (
          response.data &&
          response.data.updatePaymentMethod &&
          response.data.updatePaymentMethod.user
        ) {
          const updatedUser = response.data.updatePaymentMethod.user;
          console.log('Updated user data:', updatedUser);

          setAdminUsersList((current) =>
            current.map((item) => {
              if (item.id === userId) {
                const updatedItem = {
                  ...item,
                  userDetail: {
                    ...item.userDetail,
                    payment_method: updatedUser.userDetail?.payment_method,
                    user_shops: updatedUser.userDetail?.user_shops || [],
                  },
                };
                console.log('Updated item for table:', updatedItem);
                return updatedItem;
              }
              return item;
            })
          );
        }
        handleClose();
      });
    } catch (e) {
      console.log(e);
    }
  };

  return (
    <Modal
      BackdropProps={{
        style: {
          backgroundColor: 'white',
          backdropFilter: 'blur(14px)',
          background: 'rgba(250, 250, 250, 0.8)',
        },
      }}
      open={open}
      onClose={handleClose}
      aria-labelledby="parent-modal-title"
      aria-describedby="parent-modal-description"
    >
      <Box className={styles.editPaymentMethodModal}>
        <Box className={styles.modalTitle}>
          Do you want to change the payment method for {userFullName}?
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{
              position: 'absolute',
              right: 30,
              top: 20,
              color: (theme) => theme.palette.grey[900],
            }}
          >
            <CloseIcon />
          </IconButton>
        </Box>
        <Box className={styles.modalContent}>
          <FormControl>
            <RadioGroup
              aria-labelledby="demo-radio-buttons-group-label"
              value={checkedPaymentMethod}
              name="radio-buttons-group"
              onChange={(e) => setCheckedPaymentMethod(e.target.value)}
            >
              {paymentMethods.map((item) => (
                <FormControlLabel
                  key={item.value}
                  value={item.value}
                  control={<Radio />}
                  label={<Typography className={styles.paymentMethodName}>{item.label}</Typography>}
                />
              ))}
            </RadioGroup>
          </FormControl>
        </Box>
        <Box className={styles.modalActions}>
          <ButtonBase
            className={styles.leftButton}
            onClick={() => {
              setCheckedPaymentMethod('');
              handleClose();
            }}
          >
            CANCEL
          </ButtonBase>
          <ButtonBase
            className={styles.rightButton}
            onClick={() => handleChangePaymentMethod(checkedPaymentMethod)}
          >
            CONFIRM
          </ButtonBase>
        </Box>
      </Box>
    </Modal>
  );
};

export default EditPaymentMethodModal;
